export enum Olympiada_Sub_Type {
  // Fan olimpiadalari uchun Olympiada_Type
  Main = 1, // asosiy
  Engineering = 2, // muhandislik-ixtirochilik
  RepublicExtra = 4, // respublika qo'shimcha
  Online = 8, // onlayn
  RoboCoding = 9, // robo coding olimpiadasi
  AdvancedEngineering = 10, // advanced engineering olimpiadasi

  // Xalqaro olimpiadalar uchun Olympiada_Type
  Prestigious = 16, // nufuzli
  Regional = 32, // mintaqaviy
}
